import { ofType } from "redux-observable";
import { mergeMap, debounceTime } from "rxjs/operators";
import { merge, of } from "rxjs";

import { GET_ASYNC_JOBS } from "../types";
import {
  getAsyncJobsPending,
  getAsyncJobsFulfilled,
  getAsyncJobsRejected,
} from "../actions";

import { sendApiRequest, notifyError, notifyWarning } from "../../../actions";
import { asyncJobsFiltersSelector } from "../selectors";

import { GET_ASYNC_JOBS_MESSAGES } from "../constants/organizationMessages";
import generateError from "../../../utilities/generateError";

const createPayload = (payload) => ({
  method: "get",
  url: "asyncjobs/get",
  onSuccess: [
    (response) =>
      response.data.length === 0
        ? notifyWarning(GET_ASYNC_JOBS_MESSAGES.NOT_FOUND)
        : getAsyncJobsFulfilled(response),
    (response) => getAsyncJobsFulfilled(response),
  ],
  onError: [getAsyncJobsRejected, (error) => notifyError(generateError(error))],
  data: payload,
});

const meta = {
  api: "ajaxApi",
};

const getAsyncJobsEpic$ = (action$, state$) =>
  action$.pipe(
    ofType(GET_ASYNC_JOBS.DEFAULT),
    debounceTime(500),
    mergeMap(({ payload }) => {
      const filters = asyncJobsFiltersSelector(state$.value);

      return merge(
        of(getAsyncJobsPending()),
        of(sendApiRequest(createPayload({ ...payload, ...filters }), meta))
      );
    })
  );

export default getAsyncJobsEpic$;



// WEBPACK FOOTER //
// ./src/features/organization/epics/getAsyncJobsEpic.js